

export enum EnumBalanca{
    Normal = 0,
    Unitario = 1,
    PesadoVenda = 2,
    Pesavel = 3,
    Glaciado =  4,
}
